import React from "react";

const CrossIcon = () => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="#3A383F"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9.85375 9.14604C9.90021 9.1925 9.93706 9.24765 9.9622 9.30834C9.98734 9.36904 10.0003 9.43409 10.0003 9.49979C10.0003 9.56549 9.98734 9.63054 9.9622 9.69124C9.93706 9.75194 9.90021 9.80709 9.85375 9.85354C9.8073 9.9 9.75215 9.93684 9.69145 9.96199C9.63076 9.98713 9.5657 10.0001 9.5 10.0001C9.43431 10.0001 9.36925 9.98713 9.30856 9.96199C9.24786 9.93684 9.19271 9.9 9.14625 9.85354L5 5.70666L0.853753 9.85354C0.759933 9.94736 0.632685 10.0001 0.500003 10.0001C0.367321 10.0001 0.240074 9.94736 0.146253 9.85354C0.052433 9.75972 -0.000274656 9.63247 -0.000274658 9.49979C-0.000274661 9.36711 0.052433 9.23986 0.146253 9.14604L4.29313 4.99979L0.146253 0.85354C0.052433 0.759719 -0.000274658 0.632472 -0.000274658 0.49979C-0.000274658 0.367108 0.052433 0.23986 0.146253 0.14604C0.240074 0.0522194 0.367321 -0.000488281 0.500003 -0.000488281C0.632685 -0.000488281 0.759933 0.0522194 0.853753 0.14604L5 4.29291L9.14625 0.14604C9.24007 0.0522194 9.36732 -0.000488284 9.5 -0.000488281C9.63269 -0.000488279 9.75993 0.0522194 9.85375 0.14604C9.94757 0.23986 10.0003 0.367108 10.0003 0.49979C10.0003 0.632472 9.94757 0.759719 9.85375 0.85354L5.70688 4.99979L9.85375 9.14604Z" />
    </svg>
  );
};

export default CrossIcon;
